export const getCurrentYear = (): number => {
  return new Date().getFullYear()
}
